import * as React from 'react';
import { useSelector } from 'react-redux';

import { PriceInfo } from '../../components/PriceInfo/PriceInfo';
import { PriceDropdownContainer } from '../../components/price_dropdown/container';
import { selectPriceAside } from '../../selectors/price/selectPriceAside';
import { withNoBreakSpaces } from '../../utils/formatters';
import { PriceHistoryContainer } from '../PriceHistory/PriceHistory';

export const PriceContainer = () => {
  const price = useSelector(selectPriceAside);

  if (!price) {
    return null;
  }

  return (
    <PriceInfo
      price={withNoBreakSpaces(price)}
      priceHistory={<PriceHistoryContainer />}
      priceInOtherCurrencies={<PriceDropdownContainer />}
    />
  );
};
